export default __webpack_public_path__ + "static/media/rooftop_rainwater_harvesting.9e55b9af.png";